module.exports = __webpack_public_path__ + "static/media/lip.07b6c438.svg";